import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import {
    aboutImg2,
    aboutUs,
    team1,
    team2,
    team3,
    team4,
    testimonial1,
    testimonial2,
    testimonial3,
} from "../../Constant";

function Aboutus() {
    return (
        <>
            <Header />
            <section
                className="servcies py-10"
                // style={{background: url('img/about-us.jpg');"
                style={{ backgroundImage: `url(${aboutUs})` }}
            >
                <div className="container hero supplement ">
                    <div className="row">
                        <div className="col-md-6 py-10">
                            <h1 className="white">Care Begins at Home</h1>
                            <p className="white">
                                We do not just give hopes but act on our promise
                                for care and independence with the most-secure
                                and compassionate health & homecare solutions.
                            </p>
                        </div>
                        <div className="col-md-6"></div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container">
                    <div className="row ">
                        <div className="col-md-12">
                            <h2 className="grey text-center bottom-line">
                                Improving Lives Together!
                            </h2>
                            <p className="text-center">
                                My Home Helper has been an industry leader in
                                providing quality home care and healthcare
                                services to members of the communities. To us,
                                it's not the client's family or home. We treat
                                everyone as part of our family and our home.
                                That’s why we stand out among the competitors.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="container py-5">
                    <div className="row">
                        <div className="col-md-4 col-sm-6">
                            <div className="counter">
                                <span className="counter-value">500</span>
                                <span className="plus">+</span>
                                <h5 className="blue">Award-Winning</h5>
                                <p>
                                    No organization has given us awards, but our
                                    customers do every day
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-6">
                            <div className="counter">
                                <span className="counter-value">1000 </span>
                                <span className="plus">+</span>
                                <h5 className="blue">Caregivers</h5>
                                <p>
                                    A social network site that enables families
                                    to find care providers quickly and easily.
                                </p>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-6">
                            <div className="counter pink">
                                <span className="counter-value">100</span>
                                <span className="plus">%</span>
                                <h5 className="blue">Satisfaction</h5>
                                <p>
                                    We care about our customers and continuously
                                    work to exceed their expectations.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section
                className="py-10"
                style={{
                    backgroundImage: `url(${aboutImg2})`,
                    backgroundRepeat: "no-repeat",
                }}
            >
                <div className="container hero  ">
                    <div className="row">
                        <div className="col-md-8 py-5"></div>
                        <div className="col-md-4 ">
                            <div className="box-list">
                                <h3 className="blue">
                                    It's a little bit matchmaker, a little bit
                                    of Uber!
                                </h3>
                                <ul className="list-unstyled ul-color">
                                    <li>
                                        <FontAwesomeIcon icon={faCheck} />
                                        &nbsp; Find the perfect caregiver
                                        closest to you{" "}
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCheck} />
                                        &nbsp; Filter the searches as per your
                                        budget
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCheck} />
                                        &nbsp; Check reviews and ratings of the
                                        caregiver
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCheck} />
                                        &nbsp; See their availability.
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCheck} />
                                        &nbsp; Chat with custom replies
                                    </li>
                                    <li>
                                        <FontAwesomeIcon icon={faCheck} />
                                        &nbsp; When you find your favorite, book
                                        in advance
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section>
                <div className="container">
                    <div className="row ">
                        <div className="col-md-12">
                            <h2 className="grey text-center bottom-line">
                                A professional &amp; friendly care provider
                            </h2>{" "}
                            <br />
                            <p className="text-center">
                                We are driven to provide amiable services that
                                you cannot forget. With our services, move
                                seamlessly between work and personal life, have
                                24/7 access to the help you need, and obtain
                                knowledge about your provider's background prior
                                to hiring.
                            </p>
                        </div>
                    </div>

                    <div className="row team">
                        <div className="col-md-3 img-gradient">
                            <img
                                className="card-img-top"
                                src={team1}
                                alt="Card image cap"
                            />
                            <div className="caption text-center">
                                <h3 className="card-title white">
                                    Maurice Becker
                                </h3>
                                <p className="white">Home Nurse</p>
                            </div>
                        </div>
                        <div className="col-md-3   img-gradient">
                            <img
                                className="card-img-top"
                                src={team2}
                                alt="Card image cap"
                            />
                            <div className="caption text-center">
                                <h3 className="card-title white">
                                    Maurice Becker
                                </h3>
                                <p className="white">Home Nurse</p>
                            </div>
                        </div>
                        <div className="col-md-3 img-gradient">
                            <img
                                className="card-img-top"
                                src={team3}
                                alt="Card image cap"
                            />
                            <div className="caption text-center">
                                <h3 className="card-title white">
                                    Maurice Becker
                                </h3>
                                <p className="white">Home Nurse</p>
                            </div>
                        </div>
                        <div className="col-md-3 img-gradient">
                            <img
                                className="card-img-top"
                                src={team4}
                                alt="Card image cap"
                            />
                            <div className="caption text-center">
                                <h3 className="card-title white">
                                    Maurice Becker
                                </h3>
                                <p className="white">Home Nurse</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="testimonial">
                <div className="container" style={{ padding: "40px" }}>
                    <div className="row text-center">
                        <div className="col-md-12">
                            <h4 className="grey">Our Customers</h4>
                            <h2 className="orange">Our Pride</h2>
                        </div>
                    </div>
                </div>

                {/* <!--<div className="d-flex align-items-center py-5 mh-100"> <a className="carousel-control-prev text-decoration-none " href="#mycarousel" role="button" data-bs-slide="prev">
        <div className="d-flex flex-column justify-content-center me-2 ms-auto left">PREV<span className="fa fa-arrow-left"></span> </div> <span className="sr-only">Previous</span>
    </a>--> */}
                <div className="container">
                    <div
                        id="carouselExampleIndicators"
                        className="carousel slide"
                        data-ride="carousel"
                    >
                        <div className="carousel-inner d-flex">
                            <div className="carousel-item col-md-12 active">
                                <div className="row">
                                    <div className="col-lg-5 pl-0 pr-0">
                                        <img
                                            src={testimonial1}
                                            className="d-block w-100"
                                            height="450"
                                            alt="..."
                                        />
                                    </div>
                                    <div className="col-lg-7 ">
                                        <div className=" d-flex flex-column my-1 px-4 pt-5">
                                            <h4 className="name">
                                                Daniel Pearl, NY | USA{" "}
                                            </h4>
                                            <h2 className="head-t grey">
                                                Just in love with service.{" "}
                                            </h2>
                                            <div
                                                className=" justify-content-center"
                                                style={{
                                                    fontSize: "14px",
                                                    paddingTop: "10px",
                                                    paddingBottom: "10px",
                                                }}
                                            >
                                                What a great site! We have been
                                                looking for a long time for a
                                                caregiver for our elderly
                                                father, and it is so hard to
                                                find people with the right mix
                                                of skills, reliability, and
                                                compassion. Thank you for this
                                                great service!
                                            </div>
                                            <div className="rating pt-4">
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star"></span>
                                                <span className="fa fa-star"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item col-md-12">
                                <div className="row">
                                    <div className="col-lg-5 pl-0 pr-0">
                                        <img
                                            src={testimonial2}
                                            className="d-block w-100"
                                            height="450"
                                            alt="..."
                                        />
                                    </div>
                                    <div className="col-lg-7 ">
                                        <div className=" d-flex flex-column my-1 px-4 pt-5">
                                            <h4 className="name">
                                                Becky Moore, NY | USA{" "}
                                            </h4>
                                            <h2 className="head-t grey">
                                                Genuinely great people to work
                                                with!
                                            </h2>
                                            <div
                                                className=" justify-content-center"
                                                style={{
                                                    fontSize: "14px",
                                                    paddingtop: "10px",
                                                    paddingBottom: "10px",
                                                }}
                                            >
                                                Hi, I wanted to let you know
                                                that your service is amazing! I
                                                found a Caregiver for my
                                                daughter. She’s perfect! Thank
                                                you so much.
                                            </div>
                                            <div className="rating pt-4">
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star"></span>
                                                <span className="fa fa-star"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="carousel-item col-md-12">
                                <div className="row">
                                    <div className="col-lg-5 pl-0 pr-0">
                                        <img
                                            src={testimonial3}
                                            className="d-block w-100"
                                            height="450"
                                            alt="..."
                                        />{" "}
                                    </div>
                                    <div className="col-lg-7 ">
                                        <div className=" d-flex flex-column my-1 px-4 pt-5">
                                            <h4 className="name">
                                                David Johnson, NY | USA{" "}
                                            </h4>
                                            <h2 className="head-t grey">
                                                Definitely My Home Helper!
                                            </h2>
                                            <div
                                                className=" justify-content-center"
                                                style={{
                                                    fontSize: "14px",
                                                    paddingTop: "10px",
                                                    paddingBottom: "10px",
                                                }}
                                            >
                                                As a small business owner, I was
                                                getting overworked with managing
                                                work and taking care of my baby.
                                                I needed a trustworthy nanny who
                                                could ensure that all the needs
                                                of my baby were adequately met.
                                                After searching for a while, I
                                                came across My home helper, and
                                                it’s been a great relief since
                                                then. I don’t have to
                                                continuously check on my
                                                babysitters and worry till I
                                                bite all my nails off. They have
                                                been a great help, and I can’t
                                                recommend them enough. So a Big
                                                Thank You to you guys.
                                            </div>
                                            <div className="rating pt-4">
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star checked"></span>
                                                <span className="fa fa-star"></span>
                                                <span className="fa fa-star"></span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!--               <a className="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">-->
            <!--                   <span className="carousel-control-prev-icon" aria-hidden="true"></span>-->
            <!--                   <span className="sr-only">Previous</span>-->
            <!--               </a>-->
            <!--               <a className="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">-->
            <!--                   <span className="carousel-control-next-icon" aria-hidden="true"></span>-->
            <!--                   <span className="sr-only">Next</span>-->
            <!--               </a>--> */}
                        <ol className="carousel-indicators pl-1">
                            <li
                                data-target="#carouselExampleIndicators"
                                data-slide-to="0"
                                className="active"
                            ></li>
                            <li
                                data-target="#carouselExampleIndicators"
                                data-slide-to="1"
                            ></li>
                            <li
                                data-target="#carouselExampleIndicators"
                                data-slide-to="2"
                            ></li>
                        </ol>
                    </div>
                </div>
                {/* <!--<a className="carousel-control-next text-decoration-none " href="#mycarousel" role="button" data-bs-slide="next">
    <div className="d-flex flex-column justify-content-center right ms-2 me-auto"> NEXT <span className="fa fa-arrow-right"></span> </div> <span className="sr-only">Next</span>
</a>--> */}
                {/* </div> */}
            </section>
            <Footer />
        </>
    );
}

export default Aboutus;
